import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { US_STATE_OPTIONS } from "@equidefi/shared";
import Select from "react-select";

export const IssuingStateSelect = ({ setFieldValue, value, isDisabled, error, isPassport, ...rest }) => {
  return (
    <FormControl mb={5} isRequired isInvalid={error}>
      <FormLabel mt="0" p="0" fontSize="md">
        {isPassport ? "State of Birth" : "Government ID Issuing State"}
      </FormLabel>
      <Select
        autoFocus={false}
        onChange={(value) => {
          setFieldValue("issuing_authority", value.value);
        }}
        isDisabled={isDisabled}
        value={US_STATE_OPTIONS.find((option) => option.value === value) || null}
        options={US_STATE_OPTIONS}
        components={{
          IndicatorSeparator: null,
        }}
        {...rest}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};
